export interface BulkMoveData {
  movedCount?: number;
  totalLeads?: number;
  results?: { status: "moved" | "skipped" | "failed"; reason?: string }[];
}

/** A bulk move returns 200 even when nothing moved; the per-agent reasons say why. */
export function bulkMoveToast(data: BulkMoveData | undefined, total: number) {
  const moved = data?.movedCount ?? 0;
  const reason = data?.results?.find((r) => r.status !== "moved")?.reason;
  const leads = data?.totalLeads ? ` · ${data.totalLeads} leads` : "";
  if (moved === 0) {
    return {
      title: "No agents moved",
      description: reason ? `${reason}.` : "Nothing was moved.",
      variant: "destructive" as const,
    };
  }
  if (moved < total) {
    return {
      title: `Moved ${moved} of ${total} agents`,
      description: `${moved} of ${total} moved${leads}.${reason ? ` Not moved: ${reason}.` : ""}`,
    };
  }
  return { title: "Agents moved", description: `${moved} of ${total} moved${leads}.` };
}
